import React from "react";
import { ShieldCheck } from "lucide-react";

/**
 * Reusable avatar.
 * Props:
 *  - user: { alias, avatar_b64, verified }
 *  - size: pixel size (default 40)
 *  - showVerified: render small verified badge
 *  - ring: white ring (e.g. on stacked avatars)
 *  - className: extra classes
 */
export default function Avatar({ user, size = 40, showVerified = false, ring = false, className = "" }) {
  const alias = user?.alias || "?";
  const src = user?.avatar_b64 ? `data:image/jpeg;base64,${user.avatar_b64}` : null;
  const initial = alias.slice(0, 1).toUpperCase();
  const ringCls = ring ? "border-2 border-white" : "";
  return (
    <div
      className={`relative rounded-full overflow-hidden shrink-0 bg-[hsl(var(--primary))] text-white flex items-center justify-center font-semibold ${ringCls} ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.4)) }}
      data-testid="avatar"
    >
      {src ? (
        <img src={src} alt={alias} className="absolute inset-0 w-full h-full object-cover" />
      ) : (
        <span aria-hidden>{initial}</span>
      )}
      {showVerified && user?.verified && (
        <span
          className="absolute -bottom-0.5 -end-0.5 rounded-full bg-white flex items-center justify-center shadow"
          style={{ width: Math.max(14, size * 0.35), height: Math.max(14, size * 0.35) }}
          aria-label="Verified"
        >
          <ShieldCheck className="text-[hsl(var(--primary))]" style={{ width: Math.max(10, size * 0.22), height: Math.max(10, size * 0.22) }} />
        </span>
      )}
    </div>
  );
}
